import I18n from '~/i18n';

const contains = {
  id: 'contains',
  name: I18n.t('filter-operation-contains')
};

const notContains = {
  id: 'notContains',
  name: I18n.t('filter-operation-not-contains')
};

const equal = {
  id: 'equal',
  name: I18n.t('filter-operation-equal')
};

const different = {
  id: 'different',
  name: I18n.t('filter-operation-different')
};

const lessThan = {
  id: 'lessThan',
  name: I18n.t('filter-operation-less-than')
};

const greaterThan = {
  id: 'greaterThan',
  name: I18n.t('filter-operation-greater-than')
};

const between = {
  id: 'between',
  name: I18n.t('filter-operation-between')
};

const isBlank = {
  id: 'isBlank',
  name: I18n.t('filter-operation-is-blank')
};

const isPresent = {
  id: 'isPresent',
  name: I18n.t('filter-operation-is-present')
};

const optionsNumeric = [
  equal,
  different,
  lessThan,
  greaterThan,
  between,
  isBlank,
  isPresent
];

export default () => ({
  numeric: optionsNumeric,
  date: optionsNumeric,
  datetime: optionsNumeric,
  time: optionsNumeric,
  currency: optionsNumeric,
  boolean: [
    equal,
  ],
  string: [
    contains,
    notContains,
    equal,
    different,
    isBlank,
    isPresent
  ],
  options: [
    equal,
    different,
    isBlank,
    isPresent
  ],
  async: [equal, different]
});
